/* unplugin-vue-components disabled */import { render } from "./ReloadConfig.vue?vue&type=template&id=28f499b6&ts=true"
import script from "./ReloadConfig.vue?vue&type=script&lang=ts"
export * from "./ReloadConfig.vue?vue&type=script&lang=ts"

import "./ReloadConfig.vue?vue&type=style&index=0&id=28f499b6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__